import { useMutation } from "urql";

import { CreateAiPromptDocument } from "../../../../graphql/generated.ts";

export function useCreateAIPrompt() {
  return useMutation(CreateAiPromptDocument);
}
